import Logo from './../../assets/images/logo.png';
import Map from './Map';
import Facebook from './../../assets/images/icon/facebook.png';
import Instagram from './../../assets/images/icon/instagram.png';
import Whatsapp from './../../assets/images/icon/whatsapp.png';
import Google from './../../assets/images/icon/google-plus.png';
import { Link } from 'react-router-dom';
const Footer = () => {
  return (
    <section className="footer" id="contact">
      <div className="container">
        <div className="row">
          <div className="col-lg-7 col-md-7">
            {/* <div className="footer-logo">
              <img src={Logo} alt="logo" />
            </div> */}
            <div className="footer-text-block">
              {/* <p align="justify">
                 We are more than just a workspace we are a partner in your entrepreneurial journey. We understand the unique needs of entrepreneurs, founders, and startup visionaries who are driven to build something extraordinary.
              </p> */}
              <Map />
            </div>
          </div>
          <div className="col-lg-5 col-md-5">
            <div className="contact-aria">
              <h4><strong>Contact Info</strong></h4>
              <ul>
                <li>
                  <a href="#"><i className="fa fa-map-marker" />
                    Karmayogi Corporate Park,
                    Orange Street, Plot No 7, Bhau Saheb Survey Nagar,
                    Trimurtee Nagar, Nagpur, 440022
                  </a>
                </li>
                <li>
                  <a href="mailto: contact@visionworkspaces.com"><i className="fa fa-envelope" />contact@visionworkspaces.com</a>
                </li>
                <li>
                  <a href="tel:+91 90826 67792"><i className="fa fa-phone" />+91 90826 67792</a>
                </li>
              </ul>
            </div>
            {/* </div>
          <div className="col-lg-4 align-self-end"> */}
            <div className="footer-icon">
              <ul>
                <li>
                  <a href="https://www.facebook.com/profile.php?id=61576085480187" target="_blank">
                    <img src={Facebook} />
                  </a>
                </li>
                <li>
                  <a href="https://wa.me/919082667792" target="_blank">
                    <img src={Whatsapp} />
                  </a>
                </li>
                <li>
                  <a href="https://g.co/kgs/GKv9GMo" target="_blank">
                    <img src={Google} />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/workspacesvision?utm_source=qr&igsh=MXE3d29pY3FrYnZ2aA==" target="_blank">
                    <img src={Instagram} />
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-copyright-text">
              <p>
                {" "}
                © <span id="newYear" />{" "}
                <a href="/" target="_blank">
                  Vision Workspaces
                </a>{" "}
              </p>
              <ul>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions">Terms & Conditions</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Footer;